module.exports = __webpack_public_path__ + "img/down_xianlai2.a3f0a6d8.png";